import type { FaireCategoryEntity } from "../../entity_types/category";

export const defaultCategory: FaireCategoryEntity = {
  token: "default",
  type: "category",
  name: "Default Category",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
